import React, { useState } from 'react';
import { ViewMode } from './PublicViewer';
import { LayoutToggle } from './LayoutToggle';
import { FilterHeader } from '../../../public-filters/presentation/components/FilterHeader';
import FilterOverlayDrawer from '../../../public-filters/presentation/components/FilterOverlayDrawer';
import { useBreakpoint } from '../../../../shared/hooks/useBreakpoint';
import { SortDropdown } from '../../../public-filters/presentation/components/sections/sort/SortDropdown';
type HeaderPublicViewerProps = {
  view: ViewMode;
  setView: (view: ViewMode) => void;
};

export function HeaderPublicViewer({ view, setView }: HeaderPublicViewerProps) {
  const [ open, setOpen ] = useState(false);
  const { isXs } = useBreakpoint();

  return (
    <header className="p-3 border-b flex flex-wrap items-center justify-between gap-3 bg-white z-10">
      {/* Left section */}
      <div className="flex flex-wrap items-center gap-3">

        {/* Filters */}
        <div className="flex flex-wrap gap-2">
          { !isXs ? <FilterHeader /> : <SortDropdown />}
          <FilterOverlayDrawer open={open} setOpen={setOpen} />
          <button
            className="border rounded px-3 py-1 text-sm flex items-center gap-1 hover:bg-gray-50
            open:bg-blue-50"
            onClick={() => setOpen(!open)}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
              Settings
          </button>
        </div>
      </div>

      {/* Right section */}
      <div className="flex items-center gap-4">

        {/* Layout Toggle passed from props */}
        <LayoutToggle value={view} onChange={setView} />

        {/* Save Search */}
        {/* <button className="border border-purple-500 text-purple-600 px-4 py-1.5 rounded hover:bg-purple-50 font-medium text-sm">
      Save Search
        </button> */}
      </div>
    </header>
  );
}
